<div class="d-flex" *ngrxLet="facets$ as facets">
  <div class="me-2 min-w-md">
    <apm-brand-selection
      [acceptedValues]="facets.brands"
      [selectedBrand]="selectedBrands()"
      (brandChanged)="onBrandsChanged($event)"
      bindValue="id"
    ></apm-brand-selection>
  </div>
  @if (withSegment()) {
    <div class="me-2 min-w-md">
      <apm-segment-selection
        [acceptedValues]="facets.segments"
        [selectedSegment]="selectedSegments()"
        (segmentChanged)="onSegmentsChanged($event)"
        bindValue="id"
      ></apm-segment-selection>
    </div>
  }
</div>
